import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.providers';

if (environment.enableGoogleAnalytics) {
  const node = document.createElement('script');
  node.src = `https://www.googletagmanager.com/gtag/js?id=G-MGB9XY43CD`;
  node.async = true;
  document.getElementsByTagName('head')[0].appendChild(node);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
